/*
 * @Description:
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  请选择部门和用户: '请选择部门和用户',
  请选择日期: '请选择日期',
  数据概览: '数据概览',
  线索总数: '线索总数',
  环比: '环比',
  动态记录数: '动态记录数',
  超: '超',
  个: '个',
  元: '元',
  待处理: '待处理',
  外呼接通数: '外呼接通数',
  日程数: '日程数',
  商机数: '商机数',
  线索及时跟进率: '线索及时跟进率',
  分配线索数: '分配线索数',
  '40分钟内跟进线索数': '40分钟内跟进线索数',
  状态分布: '状态分布',
  建议转化: '建议转化',
  建议无效: '建议无效',
  待定: '待定',
  点击: '点击',
  待跟进线索: '待跟进线索',
  数据加载中: '数据加载中',
  跟进人: '跟进人',
  时间: '时间',
  总数: '总数',
  获取数据失败: '获取数据失败',
  日程安排: '日程安排',
  线索已删除: '线索已删除',
  创建人: '创建人',
  抱歉: '抱歉！未找到该条数据',
  已删除: '数据已删除，不可查看详情',
  周日: '周日',
  周一: '周一',
  周二: '周二',
  周三: '周三',
  周四: '周四',
  周五: '周五',
  周六: '周六',
  日: '日',
  业绩概览参数: '业绩概览参数',
  实时概况参数: '实时概况参数',
  过程结果: '过程结果',
  数据结果: '数据结果',
  选中所有: '选中所有',
  数据指标: '数据指标',
  实时概况: '实时概况',
  订单产品金额: '订单产品金额',
  商机漏斗: '商机漏斗',
  商机总数: '商机总数',
  商机总额: '商机总额',
  线索转化: '线索转化',
  指标名称: '指标名称',
  业绩概览: '业绩概览',
  转化率: '转化率',
  转化为客户的线索: '转化为客户的线索',
  转化为商机的线索: '转化为商机的线索',
  转化为订单的线索: '转化为订单的线索',
  '转化率计算规则：N%=（当前指标数/总的线索数）*100%': '转化率计算规则：N%=（当前指标数/总的线索数）*100%'
};
